import evalService from "../../../services/eval.service";
import { SET_MESSAGE } from "../message/type";
import {
  LIST_EVAL_DESACTIVER_SUCCESS,
  LIST_EVAL_DESACTIVER_FAIL,
  DEACTIVATE_EVAL_SUCCESS,
  DEACTIVATE_EVAL_FAIL,
  LIST_EVAL_FAIL,
  LIST_EVAL_SUCCESS,
  ONE_EVAL_SUCCESS,
  ONE_EVAL_FAIL,
  CREATE_EVAL_SUCCESS,
  CREATE_EVAL_FAIL,
  ME_EVAL_SUCCESS,
  ME_EVAL_FAIL,
  SEARCH_EVAL_SUCCESS,
  SEARCH_EVAL_FAIL,
  EVALS_TO_COMPARE_FAIL,
  EVALS_TO_COMPARE_SUCCESS,
} from "./type";

export const createEval = (data) => (dispatch) => {
  return evalService.createEvals(data).then(
    (response) => {
      dispatch({
        type: CREATE_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: CREATE_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const createEvalReference = (data) => (dispatch) => {
  return evalService.createEvalReference(data).then(
    (response) => {
      dispatch({
        type: CREATE_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: CREATE_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getAllEVALs = (page, size) => (dispatch) => {
  return evalService.allEvals(page, size).then(
    (response) => {
      dispatch({
        type: LIST_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getEvalsByTenantId = ( page, size) => (dispatch) => {
  return evalService.getEvalsByTenantId(page, size).then(
    (response) => {
      dispatch({
        type: LIST_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const allEvalsDesactiver = (page, size) => (dispatch) => {
  return evalService.allEvalsDesactiver(page, size).then(
    (response) => {
      dispatch({
        type: LIST_EVAL_DESACTIVER_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_EVAL_DESACTIVER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const deactivateEval = (evalId) => (dispatch) => {
  return evalService.deactivateEval(evalId).then(
    (response) => {
      dispatch({
        type: DEACTIVATE_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: DEACTIVATE_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const getOneEval = (evalId) => (dispatch) => {
  return evalService.oneEval(evalId).then(
    (response) => {
      dispatch({
        type: ONE_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ONE_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const getEvalsToCompare = (form) => (dispatch) => {
  return evalService.getEvalsToCompare(form).then(
    (response) => {
      dispatch({
        type: EVALS_TO_COMPARE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: EVALS_TO_COMPARE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const getMesEVALs = (page, size) => (dispatch) => {
  return evalService.meEvals(page, size).then(
    (response) => {
      dispatch({
        type: ME_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ME_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getMesEVALsDesactivee = (page, size) => (dispatch) => {
  return evalService.meEvalsDesactivee(page, size).then(
    (response) => {
      dispatch({
        type: ME_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ME_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const searchEVALs = (page, size,status, keybord) => (dispatch) => {
  return evalService.search(page, size, status, keybord).then(
    (response) => {
      dispatch({
        type: SEARCH_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SEARCH_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const searchMesEvals = (page, size,status, keybord) => (dispatch) => {
  return evalService.searchMesEvals(page, size, status, keybord).then(
    (response) => {
      dispatch({
        type: SEARCH_EVAL_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SEARCH_EVAL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
